module.exports = __webpack_public_path__ + "img/clinicIcon.f95ddff9.svg";